
import { useEffect } from 'react';

interface ToastProps {
    message: string;
    onClose: () => void;
    duration?: number;
}

export const Toast = ({ message, onClose, duration = 2000 }: ToastProps) => {
    useEffect(() => {
        const timer = setTimeout(onClose, duration);
        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div style={{
            position: 'fixed',
            bottom: '80px', // Above sticky footer roughly
            left: '50%',
            transform: 'translateX(-50%)',
            background: 'rgba(0,0,0,0.85)',
            color: '#fff',
            padding: '10px 24px',
            borderRadius: '20px',
            zIndex: 4000,
            fontSize: '0.95rem',
            textAlign: 'center',
            boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
            animation: 'toastFadeIn 0.2s ease-out',
            pointerEvents: 'none' // Click through allowed
        }}>
            {message}
            <style>{`
                @keyframes toastFadeIn { from { opacity: 0; transform: translate(-50%, 10px); } to { opacity: 1; transform: translate(-50%, 0); } }
            `}</style>
        </div>
    );
};
